module.exports = __webpack_public_path__ + "img/c04_unittechscalemail_Normal_ua.39a27695.webp";